<template>
    <v-dialog v-model="show" width="500">
        <v-card>
            <v-card-title class="justify-center">
                <h3>
                    <v-icon color="red" class="mr-2">mdi-alert-circle</v-icon>
                    Confirmar Eliminación
                </h3>
            </v-card-title>
            <v-divider/>
            <v-card-text class="text-center card-body">
                <p class="p-card">
                    <slot>
                        ¿Estás seguro de que deseas <b class="text-danger">eliminar</b> este registro?
                    </slot>
                </p>
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn text color="error" @click="onCancel">
                    <v-icon left>mdi-cancel</v-icon>
                    Cancelar
                </v-btn>
                <v-btn color="error" @click="onConfirm">
                    <v-icon left>mdi-delete</v-icon>
                    Eliminar
                </v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>

<script>

export default {
    name: 'ModalDelete',
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['input', 'cancel', 'destroy'],
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    methods: {
        onConfirm() {
            this.$emit('destroy');
        },
        onCancel() {
            this.$emit('cancel');
        },
    },
}

</script>

<style>
.p-card{
    padding: 1rem;
    margin: 0;
}


.card-body {
    padding: 0 !important;
}

.text-danger {
    color: #f44336 !important;
}
</style>